module.exports = __webpack_public_path__ + "50560dcb482e8e1b0fe5c09f2eb80297.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/comment_text.svg
 ** module id = 248
 ** module chunks = 0
 **/